module.exports = __webpack_public_path__ + "static/media/portal-enter.b0a35da3.svg";